import { translocoConfig } from '@jsverse/transloco';

export const translocoConfiguration = translocoConfig({
    availableLangs: ['en', 'hr'],
    defaultLang: 'en',
    fallbackLang: 'en',
    reRenderOnLangChange: true,
    prodMode: false,
});